import React from 'react';
import type { ReactElement } from 'react';

import sdk from '@medipass/web-sdk';
type Props = {
  children: ReactElement;
};
export default class WithCleanSDK extends React.PureComponent<Props> {
  componentDidMount = () => sdk.removeStorage();
  render = () => this.props.children;
}
